import { render, staticRenderFns } from "./QuestionSVG.vue?vue&type=template&id=57c36f98&scoped=true&"
import script from "./QuestionSVG.vue?vue&type=script&lang=js&"
export * from "./QuestionSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c36f98",
  null
  
)

export default component.exports